<template>
  <div class="red--text">
    <graph-title-select :options="menuOptions" v-model="selection">
      {{ selection.title }}
    </graph-title-select>
  </div>
</template>

<script>
import GraphTitleSelect from "./GraphTitleSelect.vue";
import {
  getComponent,
  validateObjectArray,
  getConsolidatedMeasurements,
  HistoricalArray
} from "@/models/lib";
export default {
  components: {
    GraphTitleSelect
  },
  props: {
    historical: {
      type: [Object, Array]
    },
    mode: {
      type: String,
      default: "or",
      validator: v => {
        return ["or"].includes(v.toLowerCase());
      }
    }
  },
  data: () => ({
    selection: {},
    compParams: { feature_name: "Portfolio", name: "GenerationTabs" },
    component: null,
    config: {},
    items: [],

    pathNames: [],
    pathNameGroups: {},

    defaultIntervals: ["monthly", "daily", "hourly"],

    /**
     * will be exported as a configuration in specific measurements
     * Used to display a formatted text
     */
    intervalsText: {
      monthly: "Geração mês a mês",
      // weekly: "Geração semana a semana",
      daily: "Geração dia a dia",
      hourly: "Geração hora a hora"
    },

    intervals: {
      history: []
    },

    menuOptions: []
  }),
  watch: {
    historical: {
      immediate: true,
      handler(v) {
        v = Array.isArray(v) ? v : [v];
        if (validateObjectArray(v, ["name", "node"])) {
          this.items = v;
          this.reset();
          this.start();
        }
      }
    },
    selection: {
      handler() {
        if (!this.selection) return;
        const { interval } = this.selection;

        const instances = this.intervals;
        this.$emit("select", { interval, instances });
        this.timeOcurred();
      }
    }
  },
  methods: {
    reset() {
      this.intervals = { history: [] };
    },
    async fetchComponent() {
      if (this.component) return;

      this.component = await getComponent(this.compParams);

      if (!this.component) {
        return;
      }

      await this.component.setSpecific();
    },
    async start() {
      try {
        await this.fetchComponent();

        const list = this.getNodes();
        this.pathNames = await getConsolidatedMeasurements({
          name: list.map(e => e.path),
          mode: this.mode
        });
        if (this.pathNames.length) {
          this.createInstances();
          this.buildMenuOptions();
        }
      } catch (error) {
        console.error(error);
      }
    },
    getNodes() {
      const pathNames = [];
      this.items.forEach(item => {
        const { node } = item;
        const path = this.assureCompability(node);
        pathNames.push({ item, path });
      });
      return pathNames;
    },

    assureCompability(node = "") {
      const endingNodes = this.defaultIntervals;
      // maybe will need to deals with hdaily and hmonthly
      let lower = node.toLowerCase();
      endingNodes.forEach(ending => {
        if (lower.includes(ending)) {
          lower = lower.replace(ending, "");
          // endswith . maybe is important
          // maybe will be needed a proper handle for that
          // preventing .. to appear on meaurement's nodes
        }
      });
      return lower;
    },

    createInstances() {
      const nodes = this.getNodes();
      this.pathNames.forEach(pathName => {
        const pathLower = pathName.toLowerCase();
        const node = nodes.find(node => pathLower.includes(node.path));
        this.addInstance(pathName, node.item);
      });
      Object.keys(this.intervals).forEach(key => {
        if (key === "history") return;
        this.intervals[key] = new HistoricalArray(this.intervals[key]);
      });
    },

    addInstance(pathName, historical) {
      const pathLower = pathName.toLowerCase();
      if (this.intervals.history.includes(pathLower)) {
        return null;
      }
      const key = this.defaultIntervals.find(period => pathLower.includes(period));
      if (!Array.isArray(this.intervals[key])) {
        this.intervals[key] = [];
      }
      const instance = historical.assignCopy({ node: pathName });
      this.intervals[key].push(instance);
      this.intervals.history.push(pathLower);
    },

    countIntervals() {
      const counter = {};
      this.pathNames.forEach(name => {
        name = name.toLowerCase();
        this.defaultIntervals.forEach(v => {
          if (!name.includes(v)) return;
          if (!counter[v]) {
            counter[v] = 0;
          }
          counter[v] = counter[v] + 1;
        });
      });
      return counter;
    },

    buildMenuOptions() {
      const counter = this.countIntervals();
      const options = [];

      this.defaultIntervals.forEach(interval => {
        if (this.items.length === counter[interval]) {
          options.push({
            title: this.intervalsText[interval],
            interval
          });
        }
      });
      this.menuOptions = options;
    },
    timeOcurred() {
      this.$emit("time-ocurred", false);
    }
  }
};
</script>

<style></style>
